import { useEffect, useMemo, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import Ayuda from './Ayuda.jsx';
import Reportes from './Reportes.jsx';
import Viajes from './Viajes.jsx';
import Empresas from './Empresas.jsx';
import Monitoreo from './Monitoreo.jsx';
import Lora from './Lora.jsx';

const MAX_FEED = 200;

const PANEL_TITLES = { map: 'Mapa', fleet: 'Flota', ayuda: 'Ayuda', reportes: 'Reportes', viajes: 'Viajes', empresas: 'Empresas', telemetry: 'Telemetría en vivo', alarms: 'Alarmas', mensajes: 'Mensajes', mantenimiento: 'Mantenimiento', combustible: 'Combustible', relevadores: 'Relevadores', comandos: 'Comandos', usuarios: 'Usuarios', voz: 'Texto a voz', monitoreo: 'Cadena de frío', lora: 'Red LoRa' };

const PANEL_ICONS = {
  map: MapIcon,
  fleet: FleetIcon,
  ayuda: HelpIcon,
  reportes: ReportIcon,
  viajes: TripIcon,
  empresas: BuildingIcon,
  telemetry: TelemetryIcon,
  alarms: AlarmIcon,
  mensajes: MessageIcon,
  mantenimiento: MaintenanceIcon,
  combustible: FuelIcon,
  relevadores: PowerIcon,
  comandos: CmdIcon,
  usuarios: UserIcon,
  voz: VoiceIcon,
  monitoreo: ThermometerIcon,
  lora: RadioIcon,
};

function PanelTitleIcon({ panel }) {
  const I = PANEL_ICONS[panel];
  return I ? <span className="panel-title-icon"><I /></span> : null;
}

function fmtTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleTimeString('es-MX', { hour12: false });
}

function fmtDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '—' : d.toLocaleString('es-MX', { hour12: false });
}

function fmtPayload(p) {
  if (p == null) return '';
  return typeof p === 'string' ? p : JSON.stringify(p);
}

function setIfArray(setter) {
  return (d) => { if (Array.isArray(d)) setter(d); };
}

function SunIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

function CmdIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="4 17 10 11 4 5" />
      <line x1="12" y1="19" x2="20" y2="19" />
    </svg>
  );
}

function ReportIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="20" x2="12" y2="10" />
      <line x1="18" y1="20" x2="18" y2="4" />
      <line x1="6" y1="20" x2="6" y2="16" />
    </svg>
  );
}

function AlarmIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

function ConfigIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

function PlusIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

function MenuIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

function TelemetryIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  );
}

function SaveIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  );
}

function DownloadIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
}

function SendIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  );
}

function PlayIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="5 3 19 12 5 21 5 3" />
    </svg>
  );
}

function VoiceIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
    </svg>
  );
}

function CopyIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
}

function TrashIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  );
}

function PowerIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18.36 6.64a9 9 0 1 1-12.73 0" />
      <line x1="12" y1="2" x2="12" y2="12" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

function PauseIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="4" width="4" height="16" />
      <rect x="14" y="4" width="4" height="16" />
    </svg>
  );
}

function MapIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function HomeIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  );
}

function MaintenanceIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </svg>
  );
}

function FuelIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 22V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16" />
      <line x1="3" y1="22" x2="13" y2="22" />
      <path d="M9 4V2" />
      <line x1="7" y1="10" x2="9" y2="10" />
      <line x1="7" y1="14" x2="9" y2="14" />
      <line x1="7" y1="18" x2="9" y2="18" />
      <path d="M13 9h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2" />
      <path d="M16 5h3a1 1 0 0 1 1 1v4" />
    </svg>
  );
}

function ThermometerIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z" />
    </svg>
  );
}

function RadioIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4.9 19.1C1 15.2 1 8.8 4.9 4.9" />
      <path d="M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5" />
      <circle cx="12" cy="12" r="2" />
      <path d="M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5" />
      <path d="M19.1 4.9C23 8.8 23 15.2 19.1 19.1" />
    </svg>
  );
}

function MessageIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
}

function ChipIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="7" y="7" width="10" height="10" rx="2" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2" />
    </svg>
  );
}

function WifiIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12.55a11 11 0 0 1 14.08 0" />
      <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
      <line x1="12" y1="20" x2="12.01" y2="20" />
    </svg>
  );
}

function BuildingIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" />
      <path d="M9 22v-4h6v4" />
      <path d="M8 6h.01M16 6h.01M12 6h.01M12 10h.01M12 14h.01M16 10h.01M16 14h.01M8 10h.01M8 14h.01" />
    </svg>
  );
}

function LogoutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  );
}

function FleetIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 3h15v13H1z" />
      <path d="M16 8h4l3 3v5h-7V8z" />
      <circle cx="5.5" cy="18.5" r="2.5" />
      <circle cx="18.5" cy="18.5" r="2.5" />
    </svg>
  );
}

function TripIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6" cy="19" r="3" />
      <path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15" />
      <circle cx="18" cy="5" r="3" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

function HelpIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}


export default function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem('iot_theme') || 'dark');
  const [auth, setAuth] = useState(() => {
    try { return JSON.parse(localStorage.getItem('iot_auth') || 'null'); } catch { return null; }
  });
  const [loginUser, setLoginUser] = useState('');
  const [loginPass, setLoginPass] = useState('');
  const [loginError, setLoginError] = useState('');
  const [forgotMode, setForgotMode] = useState(false);
  const [forgotMsg, setForgotMsg] = useState('');
  const [registerMode, setRegisterMode] = useState(false);
  const [regCompany, setRegCompany] = useState('');
  const [regContact, setRegContact] = useState('');
  const [regEmail, setRegEmail] = useState('');
  const [regPassword, setRegPassword] = useState('');
  const [regCompanyMsg, setRegCompanyMsg] = useState('');
  const [clients, setClients] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [feed, setFeed] = useState([]);
  const [stats, setStats] = useState(null);
  const [mqttConnected, setMqttConnected] = useState(false);
  const [socketConnected, setSocketConnected] = useState(false);
  const [filter, setFilter] = useState('');
  const [paused, setPaused] = useState(false);
  const [commands, setCommands] = useState([]);
  const [cmdDevice, setCmdDevice] = useState('');
  const [relaysByDevice, setRelaysByDevice] = useState({});
  const [msgDevice, setMsgDevice] = useState('');
  const [msgText, setMsgText] = useState('');
  const [tenants, setTenants] = useState([]);
  const [users, setUsers] = useState([]);
  const [tenantName, setTenantName] = useState('');
  const [tenantContact, setTenantContact] = useState('');
  const [tenantAddress, setTenantAddress] = useState('');
  const [tenantPhone, setTenantPhone] = useState('');
  const [tenantEmail, setTenantEmail] = useState('');
  const [tenantAdminUser, setTenantAdminUser] = useState('');
  const [tenantAdminPass, setTenantAdminPass] = useState('');
  const [tenantGiro, setTenantGiro] = useState('');
  const [superAdminMode, setSuperAdminMode] = useState('selector');
  const [tenantSearch, setTenantSearch] = useState('');
  const [expandedTenant, setExpandedTenant] = useState(null);
  const [userUsername, setUserUsername] = useState('');
  const [userPassword, setUserPassword] = useState('');
  const [userRole, setUserRole] = useState('despachador');
  const [userTenantId, setUserTenantId] = useState('');
  const [cmdType, setCmdType] = useState('reboot');
  const [cmdParams, setCmdParams] = useState('');
  const [regId, setRegId] = useState('');
  const [regName, setRegName] = useState('');
  const [regPass, setRegPass] = useState('');
  const [regAuto, setRegAuto] = useState(true);
  const [regType, setRegType] = useState('tracker');
  const [regMsg, setRegMsg] = useState(null);
  const [regLoading, setRegLoading] = useState(false);
  const [cmdModalDevice, setCmdModalDevice] = useState(null);
  const [cmdModalType, setCmdModalType] = useState('reboot');
  const [cmdModalParams, setCmdModalParams] = useState('');
  const [cmdModalMsg, setCmdModalMsg] = useState('');
  const [editDevice, setEditDevice] = useState(null);
  const [editDeviceName, setEditDeviceName] = useState('');
  const [editDeviceMsg, setEditDeviceMsg] = useState('');
  const [alarmDeviceFilter, setAlarmDeviceFilter] = useState('');
  const [reportPreset, setReportPreset] = useState('');
  const [showRegister, setShowRegister] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [panel, setPanel] = useState(null);
  const [mapOnlyDevice, setMapOnlyDevice] = useState(null);
  const [maintFilterDevice, setMaintFilterDevice] = useState(null);
  const [ctxMenu, setCtxMenu] = useState(null);
  const [mapDevices, setMapDevices] = useState([]);
  const [fleet, setFleet] = useState([]);
  const [trackDevice, setTrackDevice] = useState('');
  const [trackFrom, setTrackFrom] = useState('');
  const [trackTo, setTrackTo] = useState('');
  const [trackPoints, setTrackPoints] = useState([]);
  const [trackLoading, setTrackLoading] = useState(false);
  const [replaying, setReplaying] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [alertSettings, setAlertSettings] = useState({
    speedLimitKmh: 80,
    batteryLow: 11.5,
    fuelDropPercent: 10,
    notifyEnabled: false,
    telegramToken: '',
    telegramChatId: '',
    whatsappPhone: '',
    whatsappApikey: '',
  });
  const [geofences, setGeofences] = useState([]);
  const [geoMode, setGeoMode] = useState(null);
  const [geoName, setGeoName] = useState('');
  const [geoRadius, setGeoRadius] = useState(500);
  const [repDevice, setRepDevice] = useState('');
  const [repFrom, setRepFrom] = useState('');
  const [repTo, setRepTo] = useState('');
  const [report, setReport] = useState(null);
  const [fuelDevice, setFuelDevice] = useState('');
  const [fuelSeries, setFuelSeries] = useState([]);
  const [monitorDevice, setMonitorDevice] = useState('');
  const [maintList, setMaintList] = useState([]);
  const [maintDevice, setMaintDevice] = useState('');
  const [maintType, setMaintType] = useState('');
  const [maintDueKm, setMaintDueKm] = useState(10000);
  const [maintNotes, setMaintNotes] = useState('');
  const [odometers, setOdometers] = useState({});
  const [autos, setAutos] = useState([]);
  const [autoName, setAutoName] = useState('');
  const [autoTrigger, setAutoTrigger] = useState('geofence_enter');
  const [autoAction, setAutoAction] = useState('relay');
  const [autoParams, setAutoParams] = useState('{"relay":1,"on":true}');
  const socketRef = useRef(null);
  const myDevicesRef = useRef(new Set());
  const cmdDeviceRef = useRef('');
  const isSuperadminRef = useRef(false);
  const mapRef = useRef(null);
  const markersRef = useRef({});
  const trackLayerRef = useRef(null);
  const startMarkerRef = useRef(null);
  const endMarkerRef = useRef(null);
  const replayMarkerRef = useRef(null);
  const replayIndexRef = useRef(0);
  const replayTimerRef = useRef(null);
  const geofenceLayersRef = useRef([]);
  const geoDraftRef = useRef(null);
  const geoPolyPointsRef = useRef([]);
  const fuelChartRef = useRef(null);

  const [ttsText, setTtsText] = useState('');
  const [ttsVoice, setTtsVoice] = useState('es-MX-JorgeNeural');
  const [ttsVoices, setTtsVoices] = useState([]);
  const [ttsLoading, setTtsLoading] = useState(false);
  const [ttsError, setTtsError] = useState('');
  const [ttsAudio, setTtsAudio] = useState(null);
  const [ttsToken, setTtsToken] = useState('');
  const [ttsLoginUser, setTtsLoginUser] = useState('');
  const [ttsLoginPass, setTtsLoginPass] = useState('');
  const [ttsLoginMsg, setTtsLoginMsg] = useState('');
  const [ttsCopied, setTtsCopied] = useState(false);
  const [ttsRestarting, setTtsRestarting] = useState(false);
  const [ttsRestartMsg, setTtsRestartMsg] = useState('');
  const [ttsHealth, setTtsHealth] = useState(null);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('iot_theme', theme);
  }, [theme]);

  useEffect(() => {
    if (!ctxMenu) return;
    const close = () => setCtxMenu(null);
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    document.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('click', close);
      document.removeEventListener('keydown', onKey);
    };
  }, [ctxMenu]);

  useEffect(() => {
    isSuperadminRef.current = !!(auth && auth.role === 'superadmin');
    myDevicesRef.current = new Set(mapDevices.map((d) => d.uniqueid));
  }, [auth, mapDevices]);

  useEffect(() => {
    cmdDeviceRef.current = cmdDevice;
  }, [cmdDevice]);

  useEffect(() => {
    const socket = io();
    socketRef.current = socket;

    socket.on('connect', () => setSocketConnected(true));
    socket.on('disconnect', () => setSocketConnected(false));

    socket.on('clients', (c) => {
      setClients((c || []).filter((x) => x.username === 'backend' || myDevicesRef.current.has(x.username)));
    });
    socket.on('subscriptions', (s) => {
      setSubscriptions((s || []).filter((x) => (x.clientid || '').startsWith('iot-backend') || myDevicesRef.current.has(x.clientid)));
    });

    socket.on('backend-status', (s) => setMqttConnected(!!s.mqttConnected));
    socket.on('tts-status', (s) => setTtsHealth(s));

    socket.on('telemetry', (msg) => {
      if (paused) return;
      if (msg.username && !myDevicesRef.current.has(msg.username)) return;
      setFeed((prev) => [msg, ...prev].slice(0, MAX_FEED));
    });

    socket.on('command', (c) => {
      if (c.device_id && !myDevicesRef.current.has(c.device_id)) return;
      setCommands((prev) => [c, ...prev].slice(0, 200));
    });
    socket.on('command-ack', (a) => {
      setCommands((prev) =>
        prev.map((c) =>
          c.id === a.id
            ? { ...c, status: a.status, result: a.result, error: a.error, updated_at: a.updated_at }
            : c
        )
      );
      if (a.device_id && a.status === 'ok' && a.result) {
        try {
          const r = typeof a.result === 'string' ? JSON.parse(a.result) : a.result;
          const relay = Number(r && r.relay);
          if (r && (relay === 1 || relay === 2) && r.on != null) {
            const on = r.on === true || r.on === 'true' || r.on === 1 || r.on === '1';
            setRelaysByDevice((prev) => {
              const cur = prev[a.device_id] || { relay1: false, relay2: false };
              return { ...prev, [a.device_id]: { ...cur, ['relay' + relay]: on } };
            });
          }
        } catch (e) {}
      }
    });

    socket.on('relay-state', (s) => {
      if (s.username && !myDevicesRef.current.has(s.username)) return;
      setRelaysByDevice((prev) => ({
        ...prev,
        [s.username]: { relay1: !!s.relay1, relay2: !!s.relay2 },
      }));
    });

    socket.on('position', (p) => {
      if (p.username && !myDevicesRef.current.has(p.username)) return;
      setMapDevices((prev) => {
        const exists = prev.some((d) => d.uniqueid === p.username);
        if (exists) {
          return prev.map((d) =>
            d.uniqueid === p.username
              ? { ...d, latitude: p.latitude, longitude: p.longitude, speed: p.speed, status: 'online', lastupdate: p.receivedAt }
              : d
          );
        }
        return [...prev, {
          id: p.username,
          name: p.username,
          uniqueid: p.username,
          status: 'online',
          latitude: p.latitude,
          longitude: p.longitude,
          speed: p.speed,
          lastupdate: p.receivedAt,
        }];
      });
    });

    socket.on('alert', (a) => {
      if (a.deviceId && !myDevicesRef.current.has(a.deviceId)) return;
      setAlerts((prev) => [a, ...prev].slice(0, 200));
    });

    return () => socket.disconnect();
  }, [paused]);

  useEffect(() => {
    if (!auth) return;
    const h = authHeaders();
    fetch('/api/clients', { headers: h }).then((r) => r.json()).then(setIfArray(setClients)).catch(() => {});
    fetch('/api/subscriptions', { headers: h }).then((r) => r.json()).then(setIfArray(setSubscriptions)).catch(() => {});
    fetch('/api/stats', { headers: h }).then((r) => r.json()).then(setStats).catch(() => {});
    fetch('/api/telemetry?limit=200', { headers: h }).then((r) => r.json()).then(setIfArray(setFeed)).catch(() => {});
    fetch('/api/commands?limit=100', { headers: h }).then((r) => r.json()).then(setIfArray(setCommands)).catch(() => {});
    fetch('/api/map', { headers: h }).then((r) => r.json()).then(setIfArray(setMapDevices)).catch(() => {});
    fetch('/api/alerts?limit=100', { headers: h }).then((r) => r.json()).then(setIfArray(setAlerts)).catch(() => {});
    fetch('/api/settings', { headers: h }).then((r) => r.json()).then(setAlertSettings).catch(() => {});
    fetch('/api/geofences', { headers: h }).then((r) => r.json()).then(setIfArray(setGeofences)).catch(() => {});
    fetch('/api/tts/status', { headers: h }).then((r) => r.json()).then(setTtsHealth).catch(() => {});
    loadRelays();
  }, [auth]);

  useEffect(() => {
    if (!auth) return;
    const h = authHeaders();
    const load = () => fetch('/api/tts/status', { headers: h }).then((r) => r.json()).then(setTtsHealth).catch(() => {});
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [auth]);

  useEffect(() => {
    if (!auth) return;
    const h = authHeaders();
    const t = setInterval(() => {
      fetch('/api/stats', { headers: h }).then((r) => r.json()).then(setStats).catch(() => {});
      loadRelays();
    }, 10000);
    return () => clearInterval(t);
  }, [auth]);

  useEffect(() => {
    if (!auth) return;
    const h = authHeaders();
    const load = () => fetch('/api/map', { headers: h }).then((r) => r.json()).then(setIfArray(setMapDevices)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [auth]);

  useEffect(() => {
    if (!auth) return;
    const h = authHeaders();
    const loadFleet = () => fetch('/api/fleet', { headers: h }).then((r) => r.json()).then(setIfArray(setFleet)).catch(() => {});
    loadFleet();
    const t = setInterval(loadFleet, 15000);
    return () => clearInterval(t);
  }, [auth]);

  useEffect(() => {
    if (panel !== 'map') return;
    const el = document.getElementById('map');
    if (!el || mapRef.current) return;
    const map = L.map('map').setView([24.8091, -107.3940], 7);

    const osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap contributors',
    });

    const satellite = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
      maxZoom: 19,
      attribution: 'Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics',
    });

    const topo = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
      maxZoom: 19,
      attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ',
    });

    osm.addTo(map);

    L.control.layers(
      { 'Mapa (OSM)': osm, 'Satélite (Esri)': satellite, 'Topográfico': topo },
      null,
      { position: 'topright' }
    ).addTo(map);

    const FullscreenControl = L.Control.extend({
      options: { position: 'topright' },
      onAdd() {
        const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
        const btn = L.DomUtil.create('a', '', container);
        btn.href = '#';
        btn.title = 'Pantalla completa (Esc para salir)';
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/></svg>';
        btn.style.lineHeight = '26px';
        L.DomEvent.on(btn, 'click', (e) => {
          L.DomEvent.stop(e);
          L.DomEvent.preventDefault(e);
          toggleMapFullscreen();
        });
        return container;
      },
    });
    map.addControl(new FullscreenControl());

    map.on('contextmenu', (e) => {
      setCtxMenu({
        x: e.originalEvent.clientX,
        y: e.originalEvent.clientY,
        kind: 'map',
        latlng: e.latlng,
      });
    });

    const onFsChange = () => {
      if (mapRef.current) mapRef.current.invalidateSize();
    };
    document.addEventListener('fullscreenchange', onFsChange);

    mapRef.current = map;
    return () => {
      document.removeEventListener('fullscreenchange', onFsChange);
      if (replayTimerRef.current) { clearInterval(replayTimerRef.current); replayTimerRef.current = null; }
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
        markersRef.current = {};
      }
      trackLayerRef.current = null;
      startMarkerRef.current = null;
      endMarkerRef.current = null;
      replayMarkerRef.current = null;
    };
  }, [panel]);

  const visibleMapDevices = useMemo(() => {
    if (!mapOnlyDevice) return mapDevices;
    return mapDevices.filter((d) => d.uniqueid === mapOnlyDevice || String(d.id) === mapOnlyDevice);
  }, [mapDevices, mapOnlyDevice]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    const seen = new Set();
    visibleMapDevices.forEach((d) => {
      if (d.latitude == null || d.longitude == null) return;
      const key = String(d.id);
      seen.add(key);
      const latlng = [d.latitude, d.longitude];
      if (markersRef.current[key]) {
        markersRef.current[key].setLatLng(latlng);
      } else {
        const marker = L.marker(latlng)
          .addTo(map)
          .bindPopup(`<b>${d.name}</b><br/>estado: ${d.status}<br/>velocidad: ${d.speed ?? '—'} km/h`)
          .bindTooltip(d.uniqueid || d.name, { permanent: true, direction: 'top', offset: [0, -8] });
        marker.on('contextmenu', (e) => {
          L.DomEvent.stopPropagation(e);
          const ll = marker.getLatLng();
          setCtxMenu({
            x: e.originalEvent.clientX,
            y: e.originalEvent.clientY,
            kind: 'device',
            device: { uniqueid: d.uniqueid, name: d.name, latitude: ll.lat, longitude: ll.lng },
          });
        });
        markersRef.current[key] = marker;
      }
    });
    Object.keys(markersRef.current).forEach((k) => {
      if (!seen.has(k)) {
        map.removeLayer(markersRef.current[k]);
        delete markersRef.current[k];
      }
    });
  }, [visibleMapDevices, panel]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    [trackLayerRef, startMarkerRef, endMarkerRef, replayMarkerRef].forEach((r) => {
      if (r.current) { map.removeLayer(r.current); r.current = null; }
    });
    if (!trackPoints.length) return;
    const latlngs = trackPoints.map((p) => [p.latitude, p.longitude]);
    trackLayerRef.current = L.polyline(latlngs, { color: '#f59e0b', weight: 4 }).addTo(map);
    startMarkerRef.current = L.circleMarker(latlngs[0], { radius: 6, color: '#34d399', fillColor: '#34d399', fillOpacity: 1 })
      .addTo(map).bindPopup(`<b>Inicio</b><br/>${fmtDateTime(trackPoints[0].devicetime)}`);
    endMarkerRef.current = L.circleMarker(latlngs[latlngs.length - 1], { radius: 6, color: '#f87171', fillColor: '#f87171', fillOpacity: 1 })
      .addTo(map).bindPopup(`<b>Fin</b><br/>${fmtDateTime(trackPoints[trackPoints.length - 1].devicetime)}`);
    map.fitBounds(trackLayerRef.current.getBounds(), { padding: [40, 40] });
    replayIndexRef.current = 0;
  }, [trackPoints, panel]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    geofenceLayersRef.current.forEach((l) => map.removeLayer(l));
    geofenceLayersRef.current = [];
    geofences.forEach((g) => {
      let layer;
      if (g.type === 'circle' && g.center_lat != null && g.center_lon != null) {
        layer = L.circle([g.center_lat, g.center_lon], { radius: g.radius, color: '#a78bfa', weight: 2, fillOpacity: 0.15 }).addTo(map);
      } else if (g.type === 'polygon' && g.points) {
        try {
          const pts = JSON.parse(g.points);
          layer = L.polygon(pts, { color: '#a78bfa', weight: 2, fillOpacity: 0.15 }).addTo(map);
        } catch {}
      }
      if (layer) {
        layer.bindPopup(`<b>${g.name}</b><br/>${g.type}`);
        geofenceLayersRef.current.push(layer);
      }
    });
  }, [geofences, panel]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map || !geoMode) return;
    const onClick = (e) => {
      const { lat, lng } = e.latlng;
      if (geoMode === 'circle') {
        createGeofenceCircle(lat, lng);
      } else if (geoMode === 'polygon') {
        geoPolyPointsRef.current.push([lat, lng]);
        drawDraftPolygon(map);
      }
    };
    const onDblClick = () => {
      if (geoMode === 'polygon') finishPolygon();
    };
    map.on('click', onClick);
    map.on('dblclick', onDblClick);
    return () => {
      map.off('click', onClick);
      map.off('dblclick', onDblClick);
    };
  }, [geoMode, geoName, geoRadius]);

  function focusDevice(d) {
    const map = mapRef.current;
    if (!map || d.latitude == null || d.longitude == null) return;
    map.flyTo([d.latitude, d.longitude], 15);
    const marker = markersRef.current[String(d.id)];
    if (marker) marker.openPopup();
  }

  function ctxHistorial(device) {
    setTrackDevice(device.uniqueid);
    loadTrack(device.uniqueid);
  }

  function ctxCentrar(device) {
    const map = mapRef.current;
    if (map && device.latitude != null && device.longitude != null) {
      map.flyTo([device.latitude, device.longitude], 15);
    }
  }

  function ctxComando(device) {
    setCtxMenu(null);
    openCmdModal(device.uniqueid);
  }

  function ctxCircle(latlng) {
    createGeofenceCircle(latlng.lat, latlng.lng);
  }

  function ctxPolygon() {
    geoPolyPointsRef.current = [];
    setGeoMode('polygon');
  }

  function ctxCentrarMapa(latlng) {
    if (mapRef.current) mapRef.current.panTo(latlng);
  }

  function toggleMapFullscreen() {
    const el = document.querySelector('.map-panel') || document.getElementById('map');
    if (!el) return;
    if (document.fullscreenElement) {
      if (document.exitFullscreen) document.exitFullscreen();
    } else if (el.requestFullscreen) {
      el.requestFullscreen();
    }
  }

  async function loadTrack(deviceIdOverride) {
    const id = deviceIdOverride || trackDevice;
    if (!id) return;
    setTrackLoading(true);
    try {
      const params = new URLSearchParams({ deviceId: id });
      if (!deviceIdOverride) {
        if (trackFrom) params.set('from', new Date(trackFrom).toISOString());
        if (trackTo) params.set('to', new Date(trackTo).toISOString());
      }
      const res = await fetch('/api/tracks?' + params.toString(), { headers: authHeaders() });
      const rows = await res.json();
      if (Array.isArray(rows)) setTrackPoints(rows);
    } catch (e) {
      alert('Error cargando recorrido: ' + e.message);
    } finally {
      setTrackLoading(false);
    }
  }

  function startReplay() {
    if (!trackPoints.length || !mapRef.current) return;
    stopReplay();
    replayIndexRef.current = 0;
    const first = trackPoints[0];
    replayMarkerRef.current = L.circleMarker([first.latitude, first.longitude], {
      radius: 7,
      color: '#38bdf8',
      fillColor: '#38bdf8',
      fillOpacity: 1,
    }).addTo(mapRef.current);
    setReplaying(true);
    replayTimerRef.current = setInterval(() => {
      replayIndexRef.current += 1;
      const idx = replayIndexRef.current;
      if (idx >= trackPoints.length) {
        stopReplay();
        return;
      }
      const p = trackPoints[idx];
      if (replayMarkerRef.current) {
        replayMarkerRef.current.setLatLng([p.latitude, p.longitude]);
      }
      if (mapRef.current) mapRef.current.panTo([p.latitude, p.longitude]);
    }, 100);
  }

  function stopReplay() {
    if (replayTimerRef.current) {
      clearInterval(replayTimerRef.current);
      replayTimerRef.current = null;
    }
    setReplaying(false);
  }

  function clearTrack() {
    stopReplay();
    setTrackPoints([]);
    const map = mapRef.current;
    if (map) {
      [trackLayerRef, startMarkerRef, endMarkerRef, replayMarkerRef].forEach((r) => {
        if (r.current) { map.removeLayer(r.current); r.current = null; }
      });
    }
  }

  async function saveAlertSettings() {
    try {
      const res = await fetch('/api/settings', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify(alertSettings),
      });
      const data = await res.json();
      setAlertSettings(data);
    } catch (e) {
      alert('Error: ' + e.message);
    }
  }

  async function reloadGeofences() {
    try {
      const res = await fetch('/api/geofences', { headers: authHeaders() });
      const data = await res.json();
      if (Array.isArray(data)) setGeofences(data);
    } catch (e) {
      alert('Error: ' + e.message);
    }
  }

  async function createGeofence(payload) {
    try {
      await fetch('/api/geofences', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify(payload),
      });
      await reloadGeofences();
    } catch (e) {
      alert('Error: ' + e.message);
    }
  }

  function createGeofenceCircle(lat, lng) {
    const name = geoName || `Círculo ${geofences.length + 1}`;
    createGeofence({ name, type: 'circle', center_lat: lat, center_lon: lng, radius: geoRadius });
    setGeoMode(null);
  }

  function drawDraftPolygon(map) {
    if (geoDraftRef.current) map.removeLayer(geoDraftRef.current);
    const pts = geoPolyPointsRef.current;
    if (pts.length >= 2) {
      geoDraftRef.current = L.polygon(pts, { color: '#a78bfa', weight: 2, dashArray: '4', fillOpacity: 0.1 }).addTo(map);
    } else if (pts.length === 1) {
      geoDraftRef.current = L.circleMarker(pts[0], { radius: 5, color: '#a78bfa' }).addTo(map);
    }
  }

  async function finishPolygon() {
    const pts = geoPolyPointsRef.current;
    if (pts.length < 3) {
      alert('Necesitas al menos 3 vértices');
      return;
    }
    const name = geoName || `Polígono ${geofences.length + 1}`;
    await createGeofence({ name, type: 'polygon', points: pts });
    geoPolyPointsRef.current = [];
    if (geoDraftRef.current && mapRef.current) {
      mapRef.current.removeLayer(geoDraftRef.current);
      geoDraftRef.current = null;
    }
    setGeoMode(null);
  }

  function cancelGeo() {
    geoPolyPointsRef.current = [];
    if (geoDraftRef.current && mapRef.current) {
      mapRef.current.removeLayer(geoDraftRef.current);
      geoDraftRef.current = null;
    }
    setGeoMode(null);
  }

  async function deleteGeofence(id) {
    try {
      await fetch(`/api/geofences/${id}`, { method: 'DELETE', headers: authHeaders() });
      await reloadGeofences();
    } catch (e) {
      alert('Error: ' + e.message);
    }
  }

  async function loadReport() {
    if (!repDevice) return;
    try {
      const params = new URLSearchParams({ deviceId: repDevice });
      if (repFrom) params.set('from', new Date(repFrom).toISOString());
      if (repTo) params.set('to', new Date(repTo).toISOString());
      const res = await fetch('/api/reports?' + params.toString(), { headers: authHeaders() });
      const data = await res.json();
      if (data && Array.isArray(data.trips)) setReport(data);
    } catch (e) {
      alert('Error: ' + e.message);
    }
  }

  useEffect(() => {
    if (!fuelChartRef.current || !fuelSeries.length) return;
    const ctx = fuelChartRef.current.getContext('2d');
    const light = theme === 'light';
    const textColor = light ? '#1a2233' : '#e6ebf5';
    const gridColor = light ? '#d9e0ea' : '#263047';
    if (window.__fuelChart) window.__fuelChart.destroy();
    window.__fuelChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: fuelSeries.map((p) => p.t.slice(11, 16)),
        datasets: [{
          label: 'Combustible (%)',
          data: fuelSeries.map((p) => p.fuel),
          borderColor: light ? '#2563eb' : '#38bdf8',
          backgroundColor: light ? 'rgba(37,99,235,0.15)' : 'rgba(56,189,248,0.15)',
          fill: true,
          tension: 0.3,
        }],
      },
      options: {
        responsive: true,
        plugins: { legend: { labels: { color: textColor } } },
        scales: {
          x: { ticks: { color: textColor }, grid: { color: gridColor } },
          y: { ticks: { color: textColor }, grid: { color: gridColor } },
        },
      },
    });
  }, [fuelSeries, theme, panel]);

  useEffect(() => {
    let token = null;
    try { token = JSON.parse(localStorage.getItem('iot_auth') || 'null'); } catch {}
    if (!token || !token.token) return;
    fetch('/api/me', { headers: { Authorization: 'Bearer ' + token.token } })
      .then((r) => {
        if (!r.ok) { localStorage.removeItem('iot_auth'); setAuth(null); }
        return r.json();
      })
      .then((d) => {
        if (d && d.username) {
          setAuth((prev) => prev ? { ...prev, username: d.username, role: d.role, tenantId: d.tenantId ?? null, tenantName: d.tenantName ?? null } : prev);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!auth) return;
    loadMaintenance();
    loadOdometers();
    loadAutomations();
    loadUsers();
    if (auth.role === 'superadmin') loadTenants();
  }, [auth, mapDevices.length]);

  function authHeaders() {
    return auth && auth.token ? { Authorization: 'Bearer ' + auth.token } : {};
  }

  async function doLogin() {
    setLoginError('');
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login: loginUser.trim(), password: loginPass }),
      });
      const data = await res.json();
      if (!res.ok) { setLoginError(data.error || 'Error al iniciar sesión'); return; }
      const authObj = { token: data.token, username: data.username, email: data.email, role: data.role, tenantId: data.tenantId ?? null, tenantName: data.tenantName ?? null };
      localStorage.setItem('iot_auth', JSON.stringify(authObj));
      setAuth(authObj);
    } catch (e) { setLoginError('Error de red: ' + e.message); }
  }

  async function doForgot() {
    setLoginError('');
    if (!loginUser.trim()) { setLoginError('Escribe tu correo'); return; }
    try {
      const res = await fetch('/api/forgot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: loginUser.trim() }),
      });
      const data = await res.json();
      if (!res.ok) { setLoginError(data.error || 'Error'); return; }
      setForgotMsg(data.resetLink ? `Enlace de restablecimiento (solo desarrollo): ${data.resetLink}` : 'Revisa tu correo para restablecer la contraseña.');
    } catch (e) { setLoginError('Error de red: ' + e.message); }
  }

  async function doRegister() {
    setLoginError('');
    setRegCompanyMsg('');
    if (!regCompany.trim()) { setLoginError('Escribe el nombre de la empresa'); return; }
    if (!regEmail.trim()) { setLoginError('Escribe el correo'); return; }
    if (!regPassword || regPassword.length < 6) { setLoginError('La contraseña debe tener al menos 6 caracteres'); return; }
    try {
      const res = await fetch('/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: regCompany.trim(), contact_name: regContact.trim() || null, email: regEmail.trim(), password: regPassword }),
      });
      const data = await res.json();
      if (!res.ok) { setLoginError(data.error || 'Error al registrar'); return; }
      setRegCompanyMsg('Empresa registrada. Revisa tu correo para activar la cuenta.');
      setRegCompany('');
      setRegContact('');
      setRegPassword('');
    } catch (e) { setLoginError('Error de red: ' + e.message); }
  }

  function doLogout() {
    localStorage.removeItem('iot_auth');
    setAuth(null);
    setPanel(null);
  }

  useEffect(() => {
    if (panel !== 'voz') return;
    setTtsToken((prev) => prev || (auth && auth.token) || '');
    fetch('/api/tts/voices')
      .then((r) => r.json())
      .then((vs) => {
        if (Array.isArray(vs)) {
          const es = vs.filter((v) => (v.locale || '').startsWith('es-'));
          setTtsVoices(es.length ? es : vs);
        }
      })
      .catch(() => {});
  }, [panel, auth]);

  useEffect(() => {
    if (panel !== 'relevadores') return;
    loadRelays();
  }, [panel, auth]);

  function copyToken() {
    const t = ttsToken || (auth && auth.token) || '';
    if (!t) return;
    navigator.clipboard.writeText(t).then(() => {
      setTtsCopied(true);
      setTimeout(() => setTtsCopied(false), 1500);
    }).catch(() => {});
  }

  function requestToken() {
    setTtsLoginMsg('');
    if (!ttsLoginUser.trim() || !ttsLoginPass) { setTtsLoginMsg('Escribe usuario y contraseña'); return; }
    fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ login: ttsLoginUser.trim(), password: ttsLoginPass }),
    })
      .then((r) => r.json())
      .then((d) => {
        if (!d.token) { setTtsLoginMsg(d.error || 'Error al obtener token'); return; }
        setTtsToken(d.token);
        setTtsLoginMsg('Token obtenido correctamente.');
        setTtsLoginPass('');
      })
      .catch((e) => setTtsLoginMsg('Error de red: ' + e.message));
  }

  async function generateVoice() {
    if (!ttsText.trim()) return;
    setTtsLoading(true);
    setTtsError('');
    if (ttsAudio) { URL.revokeObjectURL(ttsAudio); setTtsAudio(null); }
    try {
      const res = await fetch('/api/tts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ text: ttsText.trim(), voice: ttsVoice }),
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.error || 'Error al generar audio');
      }
      const blob = await res.blob();
      setTtsAudio(URL.createObjectURL(blob));
    } catch (e) {
      setTtsError(e.message);
    } finally {
      setTtsLoading(false);
    }
  }

  async function checkTts() {
    setTtsRestartMsg('');
    try {
      const res = await fetch('/api/tts/status?deep=1', { headers: authHeaders() });
      const d = await res.json().catch(() => ({}));
      setTtsHealth(d);
      setTtsRestartMsg(d.ok ? 'El servicio TTS está operativo.' : 'El servicio TTS no responde.');
    } catch (e) {
      setTtsRestartMsg('Error: ' + e.message);
    }
  }

  async function restartTts() {
    if (ttsRestarting) return;
    if (!window.confirm('¿Reiniciar el servicio TTS? Tarda unos segundos.')) return;
    setTtsRestarting(true);
    setTtsRestartMsg('');
    try {
      const res = await fetch('/api/tts/restart', { method: 'POST', headers: authHeaders() });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(d.error || 'Error al reiniciar el servicio');
      setTtsHealth((prev) => ({ ...(prev || {}), ok: !!d.healthy, checkedAt: new Date().toISOString(), error: d.healthy ? null : 'no responde tras reiniciar' }));
      setTtsRestartMsg(d.healthy ? 'Servicio reiniciado y funcionando.' : 'Servicio reiniciado; aún no responde. Revisa en unos segundos.');
      fetch('/api/tts/voices')
        .then((r) => r.json())
        .then((vs) => { if (Array.isArray(vs)) setTtsVoices(vs.filter((v) => (v.locale || '').startsWith('es-'))); })
        .catch(() => {});
    } catch (e) {
      setTtsRestartMsg('Error: ' + e.message);
    } finally {
      setTtsRestarting(false);
    }
  }

  async function selectTenant(tenantId) {
    try {
      const res = await fetch('/api/session/tenant', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ tenant_id: tenantId }),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.error || 'Error'); return; }
      setMapDevices([]);
      setFleet([]);
      setFeed([]);
      setAlerts([]);
      setCommands([]);
      setClients([]);
      setTrackPoints([]);
      setGeofences([]);
      setMaintList([]);
      setAutos([]);
      setAuth((prev) => {
        const next = { ...prev, tenantId: data.tenantId, tenantName: data.tenantName };
        localStorage.setItem('iot_auth', JSON.stringify(next));
        return next;
      });
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function leaveTenant() {
    try {
      await fetch('/api/session/tenant', { method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeaders() }, body: JSON.stringify({ tenant_id: null }) });
      setPanel(null);
      setAuth((prev) => {
        const next = { ...prev, tenantId: null, tenantName: null };
        localStorage.setItem('iot_auth', JSON.stringify(next));
        return next;
      });
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function loadFuel(deviceId) {
    const id = deviceId || fuelDevice;
    if (!id) return;
    try {
      const res = await fetch('/api/fuel?deviceId=' + encodeURIComponent(id), { headers: authHeaders() });
      const data = await res.json();
      if (Array.isArray(data)) setFuelSeries(data);
    } catch (e) {
      alert('Error: ' + e.message);
    }
  }

  async function loadMaintenance() {
    try {
      const res = await fetch('/api/maintenance', { headers: authHeaders() });
      const data = await res.json();
      if (Array.isArray(data)) setMaintList(data);
    } catch (e) {}
  }

  async function loadOdometers() {
    const map = {};
    await Promise.all(mapDevices.map(async (d) => {
      try {
        const res = await fetch('/api/odometer?deviceId=' + encodeURIComponent(d.uniqueid), { headers: authHeaders() });
        const data = await res.json();
        map[d.uniqueid] = data.km ?? 0;
      } catch {}
    }));
    setOdometers(map);
  }

  async function addMaintenance() {
    if (!maintDevice || !maintType || maintDueKm == null) return;
    try {
      await fetch('/api/maintenance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ device_id: maintDevice, type: maintType, due_km: maintDueKm, notes: maintNotes }),
      });
      setMaintType('');
      setMaintNotes('');
      await loadMaintenance();
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function markMaintenanceDone(id) {
    try {
      await fetch(`/api/maintenance/${id}/done`, { method: 'POST', headers: authHeaders() });
      await loadMaintenance();
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function deleteMaintenance(id) {
    try {
      await fetch(`/api/maintenance/${id}`, { method: 'DELETE', headers: authHeaders() });
      await loadMaintenance();
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function loadAutomations() {
    try {
      const res = await fetch('/api/automations', { headers: authHeaders() });
      const data = await res.json();
      if (Array.isArray(data)) setAutos(data);
    } catch (e) {}
  }

  async function addAutomation() {
    if (!autoName) return;
    let params = {};
    if (autoParams.trim()) {
      try { params = JSON.parse(autoParams); } catch { alert('Parámetros inválidos (JSON)'); return; }
    }
    try {
      await fetch('/api/automations', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ name: autoName, trigger_type: autoTrigger, action_type: autoAction, action_params: params }),
      });
      setAutoName('');
      await loadAutomations();
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function toggleAutomation(id) {
    try {
      await fetch(`/api/automations/${id}/toggle`, { method: 'POST', headers: authHeaders() });
      await loadAutomations();
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function deleteAutomation(id) {
    try {
      await fetch(`/api/automations/${id}`, { method: 'DELETE', headers: authHeaders() });
      await loadAutomations();
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function sendRelay(device, index, on) {
    try {
      const res = await fetch(`/api/devices/${encodeURIComponent(device)}/commands`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ type: 'relay', params: { relay: index, on } }),
      });
      const data = await res.json();
      if (!res.ok) alert(data.error || 'Error');
    } catch (e) { alert('Error: ' + e.message); }
  }

  function toggleRelay(index) {
    if (!cmdDevice) return;
    const cur = relaysByDevice[cmdDevice] || { relay1: false, relay2: false };
    const next = !cur['relay' + index];
    setRelaysByDevice((prev) => ({
      ...prev,
      [cmdDevice]: { ...(prev[cmdDevice] || { relay1: false, relay2: false }), ['relay' + index]: next },
    }));
    sendRelay(cmdDevice, index, next);
  }

  function relayIndicator(deviceId) {
    const r = relaysByDevice[deviceId];
    if (!r) return { cls: 'relay-off', label: 'Relés apagados' };
    const on = (r.relay1 ? 1 : 0) + (r.relay2 ? 2 : 0);
    if (on === 1) return { cls: 'relay-r1', label: 'Relé 1 encendido' };
    if (on === 2) return { cls: 'relay-r2', label: 'Relé 2 encendido' };
    if (on === 3) return { cls: 'relay-both', label: 'Relés 1 y 2 encendidos' };
    return { cls: 'relay-off', label: 'Relés apagados' };
  }

  async function loadRelays() {
    try {
      const res = await fetch('/api/relays', { headers: authHeaders() });
      if (res.ok) setRelaysByDevice(await res.json());
    } catch (e) {}
  }

  async function sendMessage() {
    if (!msgDevice || !msgText.trim()) return;
    try {
      const res = await fetch(`/api/devices/${encodeURIComponent(msgDevice)}/commands`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ type: 'message', params: { text: msgText.trim() } }),
      });
      const data = await res.json();
      if (!res.ok) alert(data.error || 'Error');
      else setMsgText('');
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function loadTenants() {
    try {
      const res = await fetch('/api/tenants', { headers: authHeaders() });
      if (res.ok) setTenants(await res.json());
    } catch (e) {}
  }

  async function loadUsers() {
    try {
      const res = await fetch('/api/users', { headers: authHeaders() });
      if (res.ok) setUsers(await res.json());
    } catch (e) {}
  }

  async function addTenant() {
    if (!tenantName.trim()) return;
    try {
      const res = await fetch('/api/tenants', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({
          name: tenantName.trim(),
          giro: tenantGiro || null,
          contact_name: tenantContact.trim() || null,
          address: tenantAddress.trim() || null,
          phone: tenantPhone.trim() || null,
          email: tenantEmail.trim() || null,
          admin_username: tenantAdminUser.trim() || null,
          admin_password: tenantAdminPass || null,
        }),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.error || 'Error'); return; }
      setTenantName('');
      setTenantGiro('');
      setTenantContact('');
      setTenantAddress('');
      setTenantPhone('');
      setTenantEmail('');
      setTenantAdminUser('');
      setTenantAdminPass('');
      setSuperAdminMode('selector');
      await loadTenants();
      await loadUsers();
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function addUser() {
    if (!userUsername.trim() || !userPassword) return;
    if (isSuperadmin && userRole === 'admin' && !userTenantId) { alert('Selecciona la empresa para el administrador'); return; }
    try {
      const res = await fetch('/api/users', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({
          email: userUsername.trim(),
          password: userPassword,
          role: userRole,
          tenant_id: userTenantId ? Number(userTenantId) : null,
        }),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.error || 'Error'); return; }
      setUserUsername('');
      setUserPassword('');
      await loadUsers();
    } catch (e) { alert('Error: ' + e.message); }
  }

  const filteredFeed = useMemo(() => {
    const f = filter.trim().toLowerCase();
    if (!f) return feed;
    return feed.filter(
      (m) =>
        (m.topic || '').toLowerCase().includes(f) ||
        (m.username || '').toLowerCase().includes(f) ||
        (m.client_id || '').toLowerCase().includes(f) ||
        fmtPayload(m.payload).toLowerCase().includes(f)
    );
  }, [feed, filter]);

  const filteredAlerts = useMemo(() => {
    if (!alarmDeviceFilter) return alerts;
    return alerts.filter((a) => (a.deviceId || a.device_id) === alarmDeviceFilter);
  }, [alerts, alarmDeviceFilter]);

  const alertsLastHour = useMemo(() => {
    const cutoff = Date.now() - 3600000;
    return alerts.filter((a) => {
      const t = new Date(a.createdAt || a.created_at).getTime();
      return !isNaN(t) && t >= cutoff;
    }).length;
  }, [alerts]);

  const devices = useMemo(() => clients.filter((c) => c.username && c.username !== 'backend'), [clients]);

  const clientByUsername = useMemo(() => {
    const m = {};
    for (const c of clients) if (c.username) m[c.username] = c;
    return m;
  }, [clients]);

  async function sendCmd() {
    if (!cmdDevice || !cmdType) return;
    let params = {};
    if (cmdParams.trim()) {
      try {
        params = JSON.parse(cmdParams);
      } catch {
        alert('Parámetros inválidos (debe ser JSON)');
        return;
      }
    }
    try {
      const res = await fetch(`/api/devices/${encodeURIComponent(cmdDevice)}/commands`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ type: cmdType, params }),
      });
      const data = await res.json();
      if (!res.ok) {
        alert(data.error || 'Error al enviar comando');
        return;
      }
      setCmdParams('');
    } catch (e) {
      alert('Error de red: ' + e.message);
    }
  }

  function openCmdModal(uniqueid) {
    setCmdModalDevice(uniqueid);
    setCmdModalType('reboot');
    setCmdModalParams('');
    setCmdModalMsg('');
  }

  async function sendCmdFromModal() {
    if (!cmdModalDevice || !cmdModalType) return;
    let params = {};
    if (cmdModalParams.trim()) {
      try {
        params = JSON.parse(cmdModalParams);
      } catch {
        setCmdModalMsg('Parámetros inválidos (debe ser JSON)');
        return;
      }
    }
    try {
      const res = await fetch(`/api/devices/${encodeURIComponent(cmdModalDevice)}/commands`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ type: cmdModalType, params }),
      });
      const data = await res.json();
      if (!res.ok) {
        setCmdModalMsg(data.error || 'Error al enviar comando');
        return;
      }
      setCmdModalMsg('Comando enviado correctamente.');
      setCmdModalParams('');
      fetch('/api/commands?limit=100', { headers: authHeaders() }).then((r) => r.json()).then(setIfArray(setCommands)).catch(() => {});
    } catch (e) {
      setCmdModalMsg('Error de red: ' + e.message);
    }
  }

  function openEditDevice(device) {
    setEditDevice(device);
    setEditDeviceName(device.name || '');
    setEditDeviceMsg('');
  }

  async function saveDeviceName() {
    if (!editDevice) return;
    try {
      const res = await fetch(`/api/devices/${encodeURIComponent(editDevice.uniqueid)}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ name: editDeviceName.trim(), tenant_id: auth.tenantId ?? null }),
      });
      const data = await res.json();
      if (!res.ok) { setEditDeviceMsg(data.error || 'Error'); return; }
      setEditDevice(null);
      fetch('/api/fleet', { headers: authHeaders() }).then((r) => r.json()).then(setIfArray(setFleet)).catch(() => {});
    } catch (e) { setEditDeviceMsg('Error de red: ' + e.message); }
  }

  function generatePassword(len = 12) {
    const chars = 'abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let out = '';
    for (let i = 0; i < len; i++) out += chars[Math.floor(Math.random() * chars.length)];
    return out;
  }

  async function registerDevice() {
    const id = regId.trim();
    if (!id) {
      setRegMsg({ type: 'error', text: 'Indica el ID del dispositivo' });
      return;
    }
    const needsPassword = regType === 'tracker' || regType === 'gateway';
    const password = needsPassword ? (regAuto ? generatePassword() : regPass) : '';
    if (needsPassword && !password) {
      setRegMsg({ type: 'error', text: 'Indica una contraseña o activa "autogenerar"' });
      return;
    }
    setRegLoading(true);
    setRegMsg(null);
    try {
      const res = await fetch('/api/devices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ id, name: regName.trim(), password, type: regType, tenant_id: auth.tenantId ?? null }),
      });
      const data = await res.json();
      if (!res.ok) {
        setRegMsg({ type: 'error', text: data.error || 'Error al dar de alta' });
        return;
      }
      setRegMsg({ type: 'ok', text: needsPassword ? `Dispositivo "${id}" dado de alta. Password: ${password}` : `Dispositivo "${id}" (${regType}) dado de alta.` });
      setRegId('');
      setRegName('');
      setRegPass('');
      setRegType('tracker');
      fetch('/api/fleet', { headers: authHeaders() }).then((r) => r.json()).then(setIfArray(setFleet)).catch(() => {});
    } catch (e) {
      setRegMsg({ type: 'error', text: 'Error de red: ' + e.message });
    } finally {
      setRegLoading(false);
    }
  }

  const isSuperadmin = auth && auth.role === 'superadmin';
  const isAdmin = auth && (auth.role === 'admin' || auth.role === 'superadmin');
  const isMechanic = auth && auth.role === 'mecanico';

  function renderMaintenance() {
    const list = maintFilterDevice ? maintList.filter((m) => m.device_id === maintFilterDevice) : maintList;
    return (
      <section className="card panel">
        <div className="panel-head">
          <h2>Mantenimiento{maintFilterDevice ? ` — ${maintFilterDevice}` : ''}</h2>
          {maintFilterDevice && <button className="mini icon" onClick={() => setMaintFilterDevice(null)} title="Quitar filtro"><CloseIcon /></button>}
        </div>
        {isAdmin && (
          <div className="cmd-form">
            <select value={maintDevice} onChange={(e) => setMaintDevice(e.target.value)}>
              <option value="">— Dispositivo —</option>
              {mapDevices.map((d) => <option key={d.id} value={d.uniqueid}>{d.uniqueid || d.name}</option>)}
            </select>
            <input type="text" placeholder="Tipo (ej. Cambio de aceite)" value={maintType} onChange={(e) => setMaintType(e.target.value)} />
            <input type="number" placeholder="Objetivo (km)" value={maintDueKm} onChange={(e) => setMaintDueKm(Number(e.target.value))} />
            <button className="mini icon" onClick={addMaintenance} title="Agregar mantenimiento"><PlusIcon /></button>
          </div>
        )}
        <table>
          <thead>
            <tr><th>Dispositivo</th><th>Tipo</th><th>Actual (km)</th><th>Objetivo (km)</th><th>Restante</th><th>Estado</th><th></th></tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={7} className="empty">Sin mantenimientos</td></tr>}
            {list.map((m) => {
              const current = odometers[m.device_id] ?? null;
              const remaining = current != null ? Math.round(m.due_km - current) : null;
              return (
                <tr key={m.id}>
                  <td className="mono">{m.device_id}</td>
                  <td>{m.type}</td>
                  <td>{current != null ? Math.round(current) : '—'}</td>
                  <td>{m.due_km}</td>
                  <td>{remaining != null ? remaining : '—'}</td>
                  <td>{m.done ? <span className="status status-ok">hecho</span> : <span className="status status-pending">pendiente</span>}</td>
                  <td>
                    {!m.done && <button className="mini icon" onClick={() => markMaintenanceDone(m.id)} title="Marcar hecho"><SaveIcon /></button>}
                    {isAdmin && <button className="mini icon del" onClick={() => deleteMaintenance(m.id)} title="Eliminar"><TrashIcon /></button>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
    );
  }

  if (!auth) {
    return (
      <div className="app login-wrap">
        <div className="card login-card">
          <button className="theme-toggle login-theme-toggle" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')} title={theme === 'dark' ? 'Modo claro' : 'Modo oscuro'}>
            {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
          </button>
          <div className="brand brand-center">
            <img src={theme === 'dark' ? '/logo.svg' : '/logo-dark.svg'} alt="Buyubampo" className="logo" />
          </div>
          {registerMode ? (
            <>
              <p className="dim" style={{ margin: 0 }}>Crea tu empresa y su cuenta de acceso.</p>
              <input type="text" placeholder="Nombre de la empresa" value={regCompany} onChange={(e) => setRegCompany(e.target.value)} />
              <input type="text" placeholder="Nombre de contacto (opcional)" value={regContact} onChange={(e) => setRegContact(e.target.value)} />
              <input type="text" placeholder="Correo de acceso" value={regEmail} onChange={(e) => setRegEmail(e.target.value)} />
              <input type="password" placeholder="Contraseña" value={regPassword} onChange={(e) => setRegPassword(e.target.value)} />
              <button className="login-submit" onClick={doRegister}>Registrar empresa</button>
              <button className="theme-toggle" onClick={() => { setRegisterMode(false); setRegCompanyMsg(''); setLoginError(''); }} style={{ width: '100%' }}>Volver a iniciar sesión</button>
              {regCompanyMsg && <div className="reg-msg ok">{regCompanyMsg}</div>}
            </>
          ) : forgotMode ? (
            <>
              <p className="dim" style={{ margin: 0 }}>Escribe tu correo y te enviaremos un enlace para restablecer tu contraseña.</p>
              <input type="text" placeholder="Correo electrónico" value={loginUser} onChange={(e) => setLoginUser(e.target.value)} />
              <button className="login-submit" onClick={doForgot}>Enviar enlace</button>
              <button className="theme-toggle" onClick={() => { setForgotMode(false); setForgotMsg(''); setLoginError(''); }} style={{ width: '100%' }}>Volver a iniciar sesión</button>
              {forgotMsg && <div className="reg-msg ok">{forgotMsg}</div>}
            </>
          ) : (
            <>
              <input type="text" placeholder="Correo electrónico" value={loginUser} onChange={(e) => setLoginUser(e.target.value)} />
              <input type="password" placeholder="Contraseña" value={loginPass} onChange={(e) => setLoginPass(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && doLogin()} />
              <button className="login-submit" onClick={doLogin}>Entrar</button>
              <button className="link-btn" onClick={() => { setForgotMode(true); setLoginError(''); setForgotMsg(''); }}>¿Olvidaste tu contraseña?</button>
              <button className="link-btn" onClick={() => { setRegisterMode(true); setLoginError(''); setRegCompanyMsg(''); }}>Registrar nueva empresa</button>
            </>
          )}
          {loginError && <div className="reg-msg error">{loginError}</div>}
        </div>
      </div>
    );
  }

  if (isSuperadmin && !auth.tenantId) {
    return (
      <div className="app">
        <header className="topbar">
          <div className="brand">
            <span className="brand-mark"><MapIcon /></span>
            <span className="brand-name">Buyubampo</span>
          </div>
          <div className="badges">
            <a className="home-btn" href="https://buyubampo.com" title="Volver a buyubampo.com"><HomeIcon /><span>Home</span></a>
            <span className="badge ok">{auth.username} (superadmin)</span>
            <button className="theme-toggle" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')} title={theme === 'dark' ? 'Modo claro' : 'Modo oscuro'}>
              {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
            </button>
            <button className="logout" onClick={doLogout}>Salir</button>
          </div>
        </header>
        <Empresas authHeaders={authHeaders} onEnter={selectTenant} />
      </div>
    );
  }

  if (isMechanic) {
    return (
      <div className="app">
        <header className="topbar">
          <div className="brand">
            <span className="brand-mark"><MapIcon /></span>
            <span className="brand-name">Buyubampo</span>
          </div>
          <div className="badges">
            <a className="home-btn" href="https://buyubampo.com" title="Volver a buyubampo.com"><HomeIcon /><span>Home</span></a>
            <span className="badge ok">{auth.username} (mecánico)</span>
            <button className="theme-toggle" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')} title={theme === 'dark' ? 'Modo claro' : 'Modo oscuro'}>
              {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
            </button>
            <button className="logout" onClick={doLogout}>Salir</button>
          </div>
        </header>
        {renderMaintenance()}
      </div>
    );
  }

  const relays = relaysByDevice[cmdDevice] || { relay1: false, relay2: false };

  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">
          <span className="brand-mark"><MapIcon /></span>
          <span className="brand-name">Buyubampo</span>
          {auth.tenantName && <span className="tenant-name">{auth.tenantName}</span>}
        </div>
        <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menú"><MenuIcon /></button>
        <nav className={`viewnav ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)}>
          {isSuperadmin && (
            <button onClick={() => setPanel('empresas')}>
              <BuildingIcon /><span className="nav-label">Empresas</span>
            </button>
          )}
          <button onClick={() => { setMapOnlyDevice(null); setPanel('map'); }}>
            <MapIcon /><span className="nav-label">Mapa</span>
          </button>
          <button onClick={() => setPanel('fleet')}>
            <FleetIcon /><span className="nav-label">Flota</span>
          </button>
          <button onClick={() => { setReportPreset(''); setPanel('reportes'); }}>
            <ReportIcon /><span className="nav-label">Reportes</span>
          </button>
          <button onClick={() => setPanel('viajes')}>
            <TripIcon /><span className="nav-label">Viajes</span>
          </button>
          <button onClick={() => setPanel('lora')}>
            <RadioIcon /><span className="nav-label">Red LoRa</span>
          </button>
          {isAdmin && (
            <button onClick={() => setPanel('usuarios')}>
              <UserIcon /><span className="nav-label">Usuarios</span>
            </button>
          )}
          <button onClick={() => setPanel('voz')}>
            <VoiceIcon /><span className="nav-label">Texto a voz</span>
          </button>
          <button onClick={() => setPanel('ayuda')}>
            <HelpIcon /><span className="nav-label">Ayuda</span>
          </button>
          <button onClick={doLogout}>
            <LogoutIcon /><span className="nav-label">Salir</span>
          </button>
        </nav>
        <div className="badges">
          <a className="home-btn" href="https://buyubampo.com" title="Volver a buyubampo.com"><HomeIcon /><span>Home</span></a>
          <span className={`badge ${mqttConnected ? 'ok' : 'bad'}`}>
            MQTT {mqttConnected ? 'conectado' : 'desconectado'}
          </span>
          <span className={`badge ${socketConnected ? 'ok' : 'bad'}`}>
            WebSocket {socketConnected ? 'conectado' : 'desconectado'}
          </span>
          <span className="badge ok">{auth.username}</span>
          <button className="theme-toggle" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')} title={theme === 'dark' ? 'Modo claro' : 'Modo oscuro'}>
            {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
          </button>
        </div>
      </header>

      {isSuperadmin && ttsHealth && ttsHealth.ok === false && (
        <div className="tts-down-banner">
          <span className="grow">
            <strong>Servicio TTS no disponible.</strong>{' '}
            {ttsHealth.error ? ttsHealth.error : 'No responde.'}{' '}
            {ttsHealth.autoRestartAt ? `Reinicio automático programado: ${fmtTime(ttsHealth.autoRestartAt)}.` : ''}{' '}
            {ttsHealth.autoRestarts ? `(intentos automáticos: ${ttsHealth.autoRestarts})` : ''}{' '}
            {ttsHealth.checkedAt ? `(última comprobación: ${fmtTime(ttsHealth.checkedAt)})` : ''}
          </span>
          <button className="mini add" onClick={restartTts} disabled={ttsRestarting}>
            <PowerIcon /> {ttsRestarting ? 'Reiniciando...' : 'Reiniciar TTS'}
          </button>
        </div>
      )}

      <>
      <section className="stats">
        <div className="card stat">
          <div className="stat-icon"><MessageIcon /></div>
          <div><div className="stat-value">{stats ? stats.totalMessages : '—'}</div><div className="stat-label">Mensajes totales</div></div>
        </div>
        <div className="card stat">
          <div className="stat-icon"><FleetIcon /></div>
          <div><div className="stat-value">{fleet.length}</div><div className="stat-label">Dispositivos configurados</div></div>
        </div>
        <div className="card stat">
          <div className="stat-icon"><ChipIcon /></div>
          <div><div className="stat-value">{stats ? stats.totalDevices : '—'}</div><div className="stat-label">Dispositivos vistos</div></div>
        </div>
        <div className="card stat">
          <div className="stat-icon green"><TelemetryIcon /></div>
          <div><div className="stat-value">{stats ? stats.lastHourMessages : '—'}</div><div className="stat-label">Mensajes (última hora)</div></div>
        </div>
        <div className="card stat">
          <div className="stat-icon green"><WifiIcon /></div>
          <div><div className="stat-value">{devices.length}</div><div className="stat-label">Conectados ahora</div></div>
        </div>
        <div className="card stat">
          <div className="stat-icon red"><AlarmIcon /></div>
          <div><div className="stat-value">{alertsLastHour}</div><div className="stat-label">Alarmas (última hora)</div></div>
        </div>
      </section>

      <div className="dash-sections">
      <section className="card panel">
        <div className="panel-head">
          <h2>Dispositivos</h2>
          {isAdmin && (
            <button className="mini add" onClick={() => { setRegMsg(null); setShowRegister(true); }} title="Dar de alta dispositivo">
              <PlusIcon />
            </button>
          )}
        </div>
        <table>
          <thead>
            <tr>
              <th>Dispositivo</th>
              <th>Estado</th>
              <th className="col-client">Client ID</th>
              <th className="col-ip">IP</th>
              <th className="col-connected">Conectado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {fleet.length === 0 && (
              <tr><td colSpan={6} className="empty">Sin dispositivos dados de alta</td></tr>
            )}
            {fleet.map((f) => {
              const c = clientByUsername[f.uniqueid];
              const ind = relayIndicator(f.uniqueid);
              return (
                <tr key={f.id}>
                  <td>
                    <div>{f.name || f.uniqueid}</div>
                    <div className="mono dim">{f.uniqueid}</div>
                    {f.board && <div className="dim fw">{f.board}{f.fwVersion ? ` · ${f.fwVersion}` : ''}</div>}
                  </td>
                  <td>
                    <span className="dev-status">
                      <span className={`dot mqtt ${f.mqttOnline ? 'on' : ''}`} />
                      <span className={`status ${f.mqttOnline ? 'status-ok' : 'status-error'}`}>
                        {f.mqttOnline ? 'Conectado' : 'Desconectado'}
                      </span>
                    </span>
                  </td>
                  <td className="mono dim col-client">{c ? c.clientid : '—'}</td>
                  <td className="mono dim col-ip">{c ? c.ip_address : '—'}</td>
                  <td className="dim col-connected">{c ? fmtTime(c.connected_at) : '—'}</td>
                  <td>
                    <div className="row-actions">
                      <button className="mini icon" onClick={() => { setMapOnlyDevice(f.uniqueid); setPanel('map'); }} title="Ver en mapa"><MapIcon /></button>
                      <button className="mini icon" onClick={() => openCmdModal(f.uniqueid)} title="Enviar comando"><CmdIcon /></button>
                      <button className="mini icon" onClick={() => { setMsgDevice(f.uniqueid); setPanel('mensajes'); }} title="Mensajes"><MessageIcon /></button>
                      <button className="mini icon" onClick={() => { setFilter(f.uniqueid); setPanel('telemetry'); }} title="Telemetría en vivo"><TelemetryIcon /></button>
                      <button className="mini icon" onClick={() => { setReportPreset(f.uniqueid); setPanel('reportes'); }} title="Ver reportes"><ReportIcon /></button>
                      <button className="mini icon" onClick={() => { setAlarmDeviceFilter(f.uniqueid); setPanel('alarms'); }} title="Ver alarmas"><AlarmIcon /></button>
                      <button className="mini icon" onClick={() => { setMaintFilterDevice(f.uniqueid); setMaintDevice(f.uniqueid); setPanel('mantenimiento'); }} title="Mantenimiento"><MaintenanceIcon /></button>
                      <button className="mini icon" onClick={() => { setFuelDevice(f.uniqueid); loadFuel(f.uniqueid); setPanel('combustible'); }} title="Combustible"><FuelIcon /></button>
                      <button className="mini icon" onClick={() => { setMonitorDevice(f.uniqueid); setPanel('monitoreo'); }} title="Cadena de frío"><ThermometerIcon /></button>
                      {isAdmin && <button className="mini icon" onClick={() => openEditDevice(f)} title="Configuración"><ConfigIcon /></button>}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>

      <main className="grid">
        <section className="card panel full">
          <h2>Suscripciones</h2>
          <table>
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Tópico</th>
                <th className="col-qos">QoS</th>
              </tr>
            </thead>
            <tbody>
              {subscriptions.length === 0 && (
                <tr><td colSpan={3} className="empty">Sin suscripciones</td></tr>
              )}
              {subscriptions.map((s, i) => (
                <tr key={s.clientid + s.topic + i}>
                  <td className="mono">{s.clientid}</td>
                  <td className="mono">{s.topic}</td>
                  <td className="col-qos">{s.qos}</td>
                </tr>
              ))}
            </tbody>
            </table>
        </section>
      </main>

      {isAdmin && (
      <section className="card panel">
        <h2>Automatizaciones</h2>
        <div className="cmd-form">
          <input type="text" placeholder="Nombre de la regla" value={autoName} onChange={(e) => setAutoName(e.target.value)} />
          <select value={autoTrigger} onChange={(e) => setAutoTrigger(e.target.value)}>
            <option value="geofence_enter">Entra a geocerca</option>
            <option value="geofence_exit">Sale de geocerca</option>
            <option value="overspeed">Exceso de velocidad</option>
            <option value="low_battery">Batería baja</option>
            <option value="fuel_drop">Caída de combustible</option>
            <option value="device_offline">Dispositivo desconectado</option>
            <option value="ignition_off_moving">Ignición apagada en movimiento</option>
          </select>
          <select value={autoAction} onChange={(e) => setAutoAction(e.target.value)}>
            <option value="relay">Activar relevador</option>
            <option value="webhook">Llamar webhook</option>
            <option value="mqtt">Publicar MQTT</option>
          </select>
          <input type="text" placeholder="Params JSON" value={autoParams} onChange={(e) => setAutoParams(e.target.value)} />
          <button className="mini icon" onClick={addAutomation} title="Agregar automatización"><PlusIcon /></button>
        </div>
        <table>
          <thead>
            <tr><th>Nombre</th><th>Disparador</th><th>Acción</th><th>Estado</th><th></th></tr>
          </thead>
          <tbody>
            {autos.length === 0 && <tr><td colSpan={5} className="empty">Sin automatizaciones</td></tr>}
            {autos.map((a) => (
              <tr key={a.id}>
                <td>{a.name}</td>
                <td className="mono">{a.trigger_type}</td>
                <td className="mono">{a.action_type}</td>
                <td>{a.enabled ? <span className="status status-ok">on</span> : <span className="status status-pending">off</span>}</td>
                <td>
                  <button className="mini icon" onClick={() => toggleAutomation(a.id)} title={a.enabled ? 'Desactivar' : 'Activar'}><PowerIcon /></button>
                  <button className="mini icon del" onClick={() => deleteAutomation(a.id)} title="Eliminar"><TrashIcon /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      )}
      </div>
      </>

      {panel && (
        <div className="modal-overlay" onClick={() => setPanel(null)}>
          <div className="modal panel-modal" onClick={(e) => e.stopPropagation()}>
            <div className="panel-head">
              <h2><PanelTitleIcon panel={panel} />{PANEL_TITLES[panel] || panel}</h2>
              <button className="mini icon" onClick={() => setPanel(null)} title="Cerrar"><CloseIcon /></button>
            </div>
            {panel === 'map' && (
        <>
        <section className="card track-panel">
          <h2>Historial de rutas</h2>
          <div className="cmd-form">
            <select value={trackDevice} onChange={(e) => setTrackDevice(e.target.value)}>
              <option value="">— Dispositivo —</option>
              {mapDevices.map((d) => (
                <option key={d.id} value={d.uniqueid}>{d.uniqueid || d.name}</option>
              ))}
            </select>
            <input type="datetime-local" value={trackFrom} onChange={(e) => setTrackFrom(e.target.value)} />
            <input type="datetime-local" value={trackTo} onChange={(e) => setTrackTo(e.target.value)} />
            <button onClick={loadTrack} disabled={trackLoading || !trackDevice}>
              {trackLoading ? 'Cargando...' : 'Cargar recorrido'}
            </button>
            <button onClick={startReplay} disabled={trackPoints.length === 0 || replaying}>▶ Reproducir</button>
            <button onClick={stopReplay} disabled={!replaying}>■ Detener</button>
            <button onClick={clearTrack}>Limpiar</button>
          </div>
        </section>
        {isAdmin && (
        <section className="card geofence-panel">
          <h2>Geocercas</h2>
          <div className="cmd-form">
            <input type="text" placeholder="Nombre" value={geoName} onChange={(e) => setGeoName(e.target.value)} />
            <input type="number" placeholder="Radio (m)" value={geoRadius} onChange={(e) => setGeoRadius(Number(e.target.value))} />
            <button onClick={() => setGeoMode('circle')} className={geoMode === 'circle' ? 'active' : ''}>Círculo (clic en mapa)</button>
            <button onClick={() => { geoPolyPointsRef.current = []; setGeoMode('polygon'); }} className={geoMode === 'polygon' ? 'active' : ''}>Polígono (clics + doble clic)</button>
            <button onClick={cancelGeo} disabled={!geoMode}>Cancelar</button>
          </div>
          {geofences.length === 0 && <div className="empty">Sin geocercas</div>}
          <ul className="geofence-list">
            {geofences.map((g) => (
              <li key={g.id}>
                <span className="mono">{g.name}</span>
                <span className="dim">{g.type === 'circle' ? `círculo (${g.radius}m)` : 'polígono'}</span>
                <button className="del" onClick={() => deleteGeofence(g.id)}>Eliminar</button>
              </li>
            ))}
          </ul>
        </section>
        )}
        <div className="map-layout">
          <aside className="card map-sidebar">
            <h2>Dispositivos</h2>
            <div className="map-legend">
              <span><i className="dot mqtt on" /> MQTT</span>
              <span><i className="dot traccar on" /> Localización</span>
            </div>
            {visibleMapDevices.length === 0 && <div className="empty">Sin dispositivos</div>}
            <ul className="map-device-list">
              {visibleMapDevices.map((d) => {
                const mqttOnline = clients.some((c) => c.username === d.uniqueid);
                const traccarOnline = d.status === 'online';
                return (
                  <li key={d.id} onClick={() => focusDevice(d)}>
                    <span className={`dot mqtt ${mqttOnline ? 'on' : ''}`} title="Conexión MQTT" />
                    <span className={`dot traccar ${traccarOnline ? 'on' : ''}`} title="Estado en la plataforma de localización" />
                    <span className="mono">{d.uniqueid || d.name}</span>
                  </li>
                );
              })}
            </ul>
          </aside>
          <section className="card map-panel">
            <div className="map-company-name">{auth.tenantName || 'Buyubampo'}</div>
            <div id="map" />
          </section>
        </div>
        </>
      )}

      {panel === 'telemetry' && (
        <section className="card panel feed-panel">
          <div className="feed-head">
            <h2>Telemetría en vivo</h2>
            <div className="feed-controls">
              <input
                type="text"
                placeholder="Filtrar por tópico / dispositivo / payload"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              />
              <button className="mini icon" onClick={() => setPaused((p) => !p)} title={paused ? 'Reanudar' : 'Pausar'}>
                {paused ? <PlayIcon /> : <PauseIcon />}
              </button>
              <button className="mini icon" onClick={() => setFeed([])} title="Limpiar"><TrashIcon /></button>
            </div>
          </div>
          <div className="feed">
            {filteredFeed.length === 0 && <div className="empty">Sin mensajes aún</div>}
            {filteredFeed.map((m, i) => (
              <div className="feed-row" key={m.id || `m${i}`}>
                <span className="feed-time">{fmtTime(m.receivedAt || m.received_at)}</span>
                <span className="feed-topic mono">{m.topic}</span>
                <span className="feed-user mono dim">{m.username || m.client_id || '—'}</span>
                <span className="feed-payload mono">{fmtPayload(m.payload)}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {panel === 'alarms' && (
        <section className="card panel">
          {alarmDeviceFilter && (
            <div className="cmd-form" style={{ marginBottom: 10 }}>
              <span className="dim">Mostrando solo el dispositivo: <b className="mono">{alarmDeviceFilter}</b></span>
              <button className="mini icon" onClick={() => setAlarmDeviceFilter('')} title="Quitar filtro"><CloseIcon /></button>
            </div>
          )}
          {isAdmin && (
          <div className="cmd-form">
            <label className="check">Límite velocidad (km/h)
              <input type="number" value={alertSettings.speedLimitKmh} onChange={(e) => setAlertSettings({ ...alertSettings, speedLimitKmh: Number(e.target.value) })} />
            </label>
            <label className="check">Batería baja (V)
              <input type="number" step="0.1" value={alertSettings.batteryLow} onChange={(e) => setAlertSettings({ ...alertSettings, batteryLow: Number(e.target.value) })} />
            </label>
            <label className="check">Caída combustible (%)
              <input type="number" value={alertSettings.fuelDropPercent} onChange={(e) => setAlertSettings({ ...alertSettings, fuelDropPercent: Number(e.target.value) })} />
            </label>
            <button className="mini icon" onClick={saveAlertSettings} title="Guardar umbrales"><SaveIcon /></button>
            <button className="mini icon" onClick={() => window.open('/api/alerts?format=csv')} title="Descargar CSV"><DownloadIcon /></button>
          </div>
          )}
          <table>
            <thead>
              <tr>
                <th>Hora</th>
                <th>Dispositivo</th>
                <th>Tipo</th>
                <th>Mensaje</th>
              </tr>
            </thead>
            <tbody>
              {filteredAlerts.length === 0 && <tr><td colSpan={4} className="empty">Sin alarmas</td></tr>}
              {filteredAlerts.map((a) => (
                <tr key={a.id ?? a.createdAt}>
                  <td className="dim">{fmtTime(a.createdAt || a.created_at)}</td>
                  <td className="mono">{a.deviceId || a.device_id}</td>
                  <td><span className="status status-error">{a.type}</span></td>
                  <td>{a.message}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {isAdmin && (
            <div className="notify-box">
              <h3>Notificaciones (WhatsApp / Telegram)</h3>
              <label className="check"><input type="checkbox" checked={alertSettings.notifyEnabled} onChange={(e) => setAlertSettings({ ...alertSettings, notifyEnabled: e.target.checked })} /> Activar envío de alarmas</label>
              <div className="cmd-form">
                <input type="text" placeholder="Telegram Bot Token" value={alertSettings.telegramToken} onChange={(e) => setAlertSettings({ ...alertSettings, telegramToken: e.target.value })} />
                <input type="text" placeholder="Telegram Chat ID" value={alertSettings.telegramChatId} onChange={(e) => setAlertSettings({ ...alertSettings, telegramChatId: e.target.value })} />
                <input type="text" placeholder="WhatsApp teléfono (con país)" value={alertSettings.whatsappPhone} onChange={(e) => setAlertSettings({ ...alertSettings, whatsappPhone: e.target.value })} />
                <input type="text" placeholder="WhatsApp API key (CallMeBot)" value={alertSettings.whatsappApikey} onChange={(e) => setAlertSettings({ ...alertSettings, whatsappApikey: e.target.value })} />
                <button className="mini icon" onClick={saveAlertSettings} title="Guardar"><SaveIcon /></button>
              </div>
            </div>
          )}
        </section>
      )}

      {panel === 'mensajes' && (
        <section className="card panel">
          <h2>Mensajes</h2>
          <div className="cmd-form">
            <select value={msgDevice} onChange={(e) => setMsgDevice(e.target.value)}>
              <option value="">— Dispositivo —</option>
              {devices.map((c) => (
                <option key={c.username} value={c.username}>{c.username}</option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Escribe el mensaje para el conductor..."
              value={msgText}
              onChange={(e) => setMsgText(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
            />
            <button className="mini icon" onClick={sendMessage} disabled={!msgDevice || !msgText.trim()} title="Enviar mensaje"><SendIcon /></button>
          </div>
        </section>
      )}

      {panel === 'mantenimiento' && renderMaintenance()}

      {panel === 'combustible' && (
        <section className="card panel">
          <h2>Combustible</h2>
          <div className="cmd-form">
            <select value={fuelDevice} onChange={(e) => setFuelDevice(e.target.value)}>
              <option value="">— Dispositivo —</option>
              {mapDevices.map((d) => (
                <option key={d.id} value={d.uniqueid}>{d.uniqueid || d.name}</option>
              ))}
            </select>
            <button className="mini icon" onClick={loadFuel} disabled={!fuelDevice} title="Cargar combustible"><PlayIcon /></button>
          </div>
          {fuelSeries.length === 0 && <div className="empty">Sin datos de combustible</div>}
          <div style={{ height: 240 }}>
            <canvas ref={fuelChartRef} />
          </div>
        </section>
      )}

      {panel === 'relevadores' && (
        <section className="card panel">
          <h2>Relevadores</h2>
          <div className="cmd-form">
            <select value={cmdDevice} onChange={(e) => setCmdDevice(e.target.value)}>
              <option value="">— Dispositivo —</option>
              {devices.map((c) => (
                <option key={c.username} value={c.username}>{c.username}</option>
              ))}
            </select>
            <button className={`mini relay toggle ${relays.relay1 ? '' : 'off'}`} onClick={() => toggleRelay(1)} disabled={!cmdDevice} title={relays.relay1 ? 'Apagar Relé 1' : 'Encender Relé 1'}>
              <PowerIcon /> Relé 1 <b>{relays.relay1 ? 'ON' : 'OFF'}</b>
            </button>
            <button className={`mini relay toggle ${relays.relay2 ? '' : 'off'}`} onClick={() => toggleRelay(2)} disabled={!cmdDevice} title={relays.relay2 ? 'Apagar Relé 2' : 'Encender Relé 2'}>
              <PowerIcon /> Relé 2 <b>{relays.relay2 ? 'ON' : 'OFF'}</b>
            </button>
          </div>
        </section>
      )}

      {panel === 'comandos' && (
        <section className="card panel">
          <h2>Comandos</h2>
          <table>
            <thead>
              <tr>
                <th>Dispositivo</th>
                <th>Tipo</th>
                <th>Estado</th>
                <th>Resultado</th>
                <th>Enviado</th>
              </tr>
            </thead>
            <tbody>
              {commands.length === 0 && (
                <tr><td colSpan={5} className="empty">Sin comandos aún</td></tr>
              )}
              {commands.map((c) => (
                <tr key={c.id}>
                  <td className="mono">{c.device_id}</td>
                  <td className="mono">{c.type}</td>
                  <td>
                    <span className={`status status-${c.status}`}>{c.status}</span>
                  </td>
                  <td className="mono dim">{fmtPayload(c.result ?? c.error) || '—'}</td>
                  <td className="dim">{fmtTime(c.updated_at || c.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}

      {panel === 'voz' && (
        <section className="card panel">
          <h2>Texto a voz</h2>

          <div className="cmd-form" style={{ flexWrap: 'wrap' }}>
            <label className="check" style={{ flex: '1 1 100%' }}>Token de acceso actual</label>
            <input
              type="text"
              readOnly
              value={ttsToken || (auth && auth.token) || ''}
              onFocus={(e) => e.target.select()}
              placeholder="Token (aparece al iniciar sesión o al solicitarlo abajo)"
              className="mono"
            />
            <button className="mini icon" onClick={copyToken} title="Copiar token">{ttsCopied ? <SaveIcon /> : <CopyIcon />}</button>
          </div>

          <div className="cmd-form" style={{ flexWrap: 'wrap' }}>
            <label className="check" style={{ flex: '1 1 100%' }}>Solicitar un token nuevo</label>
            <input type="text" placeholder="Correo o usuario" value={ttsLoginUser} onChange={(e) => setTtsLoginUser(e.target.value)} />
            <input type="password" placeholder="Contraseña" value={ttsLoginPass} onChange={(e) => setTtsLoginPass(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && requestToken()} />
            <button className="mini icon" onClick={requestToken} title="Solicitar token"><PlayIcon /></button>
          </div>
          {ttsLoginMsg && <div className="reg-msg ok" style={{ margin: '0 0 12px' }}>{ttsLoginMsg}</div>}

          <hr style={{ border: 'none', borderTop: '1px solid var(--border)', margin: '16px 0' }} />

          <div className="cmd-form" style={{ flexWrap: 'wrap' }}>
            <textarea
              rows={3}
              placeholder="Escribe el texto que quieres convertir en voz..."
              value={ttsText}
              onChange={(e) => setTtsText(e.target.value)}
              style={{ flex: '1 1 100%', resize: 'vertical' }}
            />
            <select value={ttsVoice} onChange={(e) => setTtsVoice(e.target.value)}>
              <option value="es-MX-JorgeNeural">es-MX-JorgeNeural (hombre)</option>
              <option value="es-MX-DaliaNeural">es-MX-DaliaNeural (mujer)</option>
              {ttsVoices.filter((v) => !['es-MX-JorgeNeural', 'es-MX-DaliaNeural'].includes(v.shortName)).map((v) => (
                <option key={v.shortName} value={v.shortName}>
                  {v.shortName}{v.gender === 'Female' ? ' (mujer)' : v.gender === 'Male' ? ' (hombre)' : ''}
                </option>
              ))}
            </select>
            <button className="mini add" onClick={generateVoice} disabled={ttsLoading || !ttsText.trim()} title="Generar audio">
              <PlayIcon />
            </button>
          </div>
          {ttsLoading && <div className="dim">Generando audio...</div>}
          {ttsError && <div className="reg-msg error">{ttsError}</div>}
          {ttsAudio && (
            <div style={{ marginTop: 12 }}>
              <audio controls src={ttsAudio} autoPlay style={{ width: '100%' }} />
            </div>
          )}

          {isSuperadmin && (
            <>
              <hr style={{ border: 'none', borderTop: '1px solid var(--border)', margin: '16px 0' }} />
              <div className="cmd-form" style={{ flexWrap: 'wrap' }}>
                <label className="check" style={{ flex: '1 1 100%' }}>Mantenimiento del servicio TTS</label>
                <span className="dim" style={{ flex: '1 1 100%' }}>
                  Reinicia edge-tts, refresca el token de Microsoft y actualiza la librería. Tarda unos segundos.
                </span>
                <span className={`badge ${ttsHealth && ttsHealth.ok ? 'ok' : ttsHealth && ttsHealth.ok === false ? 'bad' : ''}`}>
                  TTS {ttsHealth && ttsHealth.ok ? 'operativo' : ttsHealth && ttsHealth.ok === false ? 'caído' : 'sin comprobar'}
                </span>
                <button className="mini" onClick={checkTts}>Comprobar ahora</button>
                <button className="mini add" onClick={restartTts} disabled={ttsRestarting}>
                  <PowerIcon /> {ttsRestarting ? 'Reiniciando...' : 'Reiniciar servicio TTS'}
                </button>
                {ttsHealth && ttsHealth.checkedAt && (
                  <span className="dim" style={{ flex: '1 1 100%' }}>Última comprobación: {fmtTime(ttsHealth.checkedAt)}</span>
                )}
              </div>
              {ttsRestartMsg && (
                <div className={`reg-msg ${ttsRestartMsg.startsWith('Error') ? 'error' : 'ok'}`} style={{ margin: '0 0 12px' }}>
                  {ttsRestartMsg}
                </div>
              )}
            </>
          )}
        </section>
      )}

      {panel === 'usuarios' && isAdmin && (
        <section className="card panel">
          <h2>Usuarios</h2>
          <div className="cmd-form">
            <input type="text" placeholder="Correo electrónico" value={userUsername} onChange={(e) => setUserUsername(e.target.value)} />
            <input type="text" placeholder="Contraseña" value={userPassword} onChange={(e) => setUserPassword(e.target.value)} />
            <select value={userRole} onChange={(e) => setUserRole(e.target.value)}>
              {isSuperadmin && <option value="admin">Administrador</option>}
              <option value="despachador">Despachador</option>
              <option value="mecanico">Mecánico</option>
            </select>
            {isSuperadmin && userRole === 'admin' && (
              <select value={userTenantId} onChange={(e) => setUserTenantId(e.target.value)}>
                <option value="">— Empresa —</option>
                {tenants.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            )}
            <button className="mini icon" onClick={addUser} title="Crear usuario"><PlusIcon /></button>
          </div>
          <table>
            <thead>
              <tr><th>Usuario</th><th>Rol</th>{isSuperadmin && <th>Empresa</th>}</tr>
            </thead>
            <tbody>
              {users.length === 0 && <tr><td colSpan={isSuperadmin ? 3 : 2} className="empty">Sin usuarios</td></tr>}
              {users.map((u) => (
                <tr key={u.id}>
                  <td className="mono">{u.username}</td>
                  <td>{u.role}</td>
                  {isSuperadmin && <td>{u.tenant_id ? (tenants.find((t) => t.id === u.tenant_id)?.name || u.tenant_id) : '—'}</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}

      {panel === 'fleet' && (
        <>
        <section className="stats">
          <div className="card stat"><div className="stat-icon"><FleetIcon /></div><div><div className="stat-value">{fleet.length}</div><div className="stat-label">Unidades</div></div></div>
          <div className="card stat"><div className="stat-icon green"><WifiIcon /></div><div><div className="stat-value">{fleet.filter((f) => f.mqttOnline).length}</div><div className="stat-label">En línea (MQTT)</div></div></div>
          <div className="card stat"><div className="stat-icon"><MapIcon /></div><div><div className="stat-value">{fleet.filter((f) => f.status === 'online').length}</div><div className="stat-label">Reportando (localización)</div></div></div>
          <div className="card stat"><div className="stat-icon"><ReportIcon /></div><div><div className="stat-value">{Math.round(fleet.reduce((s, f) => s + (f.odometerKm || 0), 0))}</div><div className="stat-label">Km totales</div></div></div>
        </section>
        <section className="card panel">
          <h2>Panorama de flota</h2>
          <table>
            <thead>
              <tr>
                <th>Dispositivo</th>
                <th>MQTT</th>
                <th>Localización</th>
                <th>Vel. (km/h)</th>
                <th>Odómetro (km)</th>
                <th>Alarmas hoy</th>
                <th>Mant. pendiente</th>
                <th>Última act.</th>
              </tr>
            </thead>
            <tbody>
              {fleet.length === 0 && <tr><td colSpan={8} className="empty">Sin dispositivos</td></tr>}
              {fleet.map((f) => (
                <tr key={f.id}>
                  <td className="mono">{f.uniqueid || f.name}</td>
                  <td><span className={`dot mqtt ${f.mqttOnline ? 'on' : ''}`} /></td>
                  <td><span className={`dot traccar ${f.status === 'online' ? 'on' : ''}`} /></td>
                  <td>{f.speedKmh ?? '—'}</td>
                  <td>{f.odometerKm != null ? Math.round(f.odometerKm) : '—'}</td>
                  <td>{f.alertsToday > 0 ? <span className="status status-error">{f.alertsToday}</span> : '0'}</td>
                  <td>{f.pendingMaintenance > 0 ? <span className="status status-pending">{f.pendingMaintenance}</span> : '0'}</td>
                  <td className="dim">{fmtTime(f.lastupdate)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        </>
      )}

      {panel === 'ayuda' && <Ayuda isSuperadmin={isSuperadmin} token={auth && auth.token} />}

      {panel === 'reportes' && <Reportes key={reportPreset || 'all'} mapDevices={mapDevices} authHeaders={authHeaders} initialDevice={reportPreset} />}

      {panel === 'viajes' && <Viajes authHeaders={authHeaders} devices={mapDevices} />}

      {panel === 'monitoreo' && <Monitoreo devices={fleet} authHeaders={authHeaders} socketRef={socketRef} initialDevice={monitorDevice} />}

      {panel === 'lora' && <Lora devices={fleet} authHeaders={authHeaders} socketRef={socketRef} onRegister={isAdmin ? () => { setRegMsg(null); setShowRegister(true); } : null} />}

      {panel === 'empresas' && isSuperadmin && (
        <Empresas authHeaders={authHeaders} onEnter={selectTenant} />
      )}
          </div>
        </div>
      )}

      {ctxMenu && (
        <div className="ctx-menu" style={{ left: ctxMenu.x, top: ctxMenu.y }} onContextMenu={(e) => e.preventDefault()}>
          {ctxMenu.kind === 'device' ? (
            <>
              <div className="ctx-title mono">{ctxMenu.device.uniqueid}</div>
              <button onClick={() => { ctxCentrar(ctxMenu.device); setCtxMenu(null); }}>Centrar / zoom</button>
              <button onClick={() => { ctxHistorial(ctxMenu.device); setCtxMenu(null); }}>Ver historial de rutas</button>
              <button onClick={() => { ctxComando(ctxMenu.device); setCtxMenu(null); }}>Enviar comando</button>
            </>
          ) : (
            <>
              <button onClick={() => { ctxCircle(ctxMenu.latlng); setCtxMenu(null); }}>Nueva geocerca (círculo) aquí</button>
              <button onClick={() => { ctxPolygon(); setCtxMenu(null); }}>Dibujar geocerca (polígono)</button>
              <button onClick={() => { ctxCentrarMapa(ctxMenu.latlng); setCtxMenu(null); }}>Centrar mapa aquí</button>
            </>
          )}
        </div>
      )}

      {cmdModalDevice && (
        <div className="modal-overlay" onClick={() => setCmdModalDevice(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Enviar comando</h2>
            <p className="dim mono" style={{ marginTop: 0 }}>{cmdModalDevice}</p>
            <div className="cmd-form">
              <select value={cmdModalType} onChange={(e) => setCmdModalType(e.target.value)}>
                <option value="relay">Relé</option>
                <option value="message">Mensaje al conductor</option>
              </select>
              <input
                type="text"
                placeholder={cmdModalType === 'relay' ? '{"relay":1,"on":true}' : '{"text":"Hola"}'}
                value={cmdModalParams}
                onChange={(e) => setCmdModalParams(e.target.value)}
              />
              <button className="mini icon" onClick={sendCmdFromModal} title="Enviar comando"><SendIcon /></button>
              <button className="mini icon" onClick={() => setCmdModalDevice(null)} title="Cerrar"><CloseIcon /></button>
            </div>
            {cmdModalMsg && <div className="reg-msg ok">{cmdModalMsg}</div>}
          </div>
        </div>
      )}

      {editDevice && (
        <div className="modal-overlay" onClick={() => setEditDevice(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Configuración del dispositivo</h2>
            <p className="dim mono" style={{ marginTop: 0 }}>{editDevice.uniqueid}</p>
            <div className="cmd-form">
              <input
                type="text"
                placeholder="Nombre del dispositivo"
                value={editDeviceName}
                onChange={(e) => setEditDeviceName(e.target.value)}
              />
              <button className="mini icon" onClick={saveDeviceName} title="Guardar nombre"><SaveIcon /></button>
              <button className="mini icon" onClick={() => setEditDevice(null)} title="Cerrar"><CloseIcon /></button>
            </div>
            {editDeviceMsg && <div className="reg-msg error">{editDeviceMsg}</div>}
          </div>
        </div>
      )}

      {showRegister && (
        <div className="modal-overlay" onClick={() => setShowRegister(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Dar de alta dispositivo</h2>
            <div className="cmd-form">
              <select value={regType} onChange={(e) => setRegType(e.target.value)}>
                <option value="tracker">Tracker (GPS + MQTT)</option>
                <option value="gateway">Gateway LoRa (MQTT)</option>
                <option value="sensor">Sensor (sin MQTT ni GPS)</option>
                <option value="lora_tracker">Tracker LoRa (GPS)</option>
              </select>
              <input
                type="text"
                placeholder="Device ID (ej. tracker-buyubampo-02)"
                value={regId}
                onChange={(e) => setRegId(e.target.value)}
              />
              <input
                type="text"
                placeholder="Nombre (opcional)"
                value={regName}
                onChange={(e) => setRegName(e.target.value)}
              />
              {(regType === 'tracker' || regType === 'gateway') && (
                <input
                  type="text"
                  placeholder="Password"
                  value={regPass}
                  disabled={regAuto}
                  onChange={(e) => setRegPass(e.target.value)}
                />
              )}
              {(regType === 'tracker' || regType === 'gateway') && (
                <label className="check">
                  <input
                    type="checkbox"
                    checked={regAuto}
                    onChange={(e) => setRegAuto(e.target.checked)}
                  />
                  Autogenerar
                </label>
              )}
              <button className="mini icon" onClick={registerDevice} disabled={regLoading} title={regLoading ? 'Creando...' : 'Dar de alta'}><PlusIcon /></button>
              <button className="mini icon" onClick={() => setShowRegister(false)} title="Cerrar"><CloseIcon /></button>
            </div>
            {regMsg && <div className={`reg-msg ${regMsg.type}`}>{regMsg.text}</div>}
          </div>
        </div>
      )}

      <footer className="app-footer">
        <span>Buyubampo — Plataforma IoT de rastreo GPS y telemetría</span>
        <span className="dim">© {new Date().getFullYear()}</span>
      </footer>
    </div>
  );
}
